import React, { useEffect, useState } from "react";
import axios from "axios";

const DefaultWithout = () => {
    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("https://seraj.imhh.ir/api/last")
            .then((res) => {
                // مطمئن می‌شیم خروجی آرایه باشه
                console.log(res);
                if (Array.isArray(res.data)) {
                    setRows(res.data);
                } else {
                    setRows([]);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <p className="p-4">Loading...</p>;
    }

    if (!rows || rows.length === 0) {
        return <p className="p-4">No data found.</p>;
    }

    return (
        <div className="card">
            <div className="card-body">
                <h6 className="mb-4 text-15">Default Table</h6>
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="ltr:text-left rtl:text-right">
                            <tr>
                                <th className="px-3.5 py-2.5 font-semibold border-b">ID</th>
                                <th className="px-3.5 py-2.5 font-semibold border-b">Name</th>
                                <th className="px-3.5 py-2.5 font-semibold border-b">Color</th>
                                <th className="px-3.5 py-2.5 font-semibold border-b">Capacity</th>
                                <th className="px-3.5 py-2.5 font-semibold border-b">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="px-3.5 py-2.5 border-y">{row.id}</td>
                                    <td className="px-3.5 py-2.5 border-y">{row.name_patient}</td>
                                    <td className="px-3.5 py-2.5 border-y">
                                        {row.data?.color ?? "-"}
                                    </td>
                                    <td className="px-3.5 py-2.5 border-y">
                                        {row.data?.capacity ?? row.data?.["capacity GB"] ?? "-"}
                                    </td>
                                    <td className="px-3.5 py-2.5 border-y">
                                        <a
                                            href="#!"
                                            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
                                        >
                                            <i className="ri-download-2-line"></i>
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DefaultWithout;
